import { useEmployeeService } from 'domain/shared/employee';
import { FormShowTemplate, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import getAccountsValidationSchema from '../createupdate/accountsValidationSchema';
import AccountsContent from '../shared/AccountsContent';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';

const EmployeeAccountsSummary = () => {
  const { updateAccounts, getForUpdate } = useEmployeeService();
  const employeeId = useEmployeeId();
  const { addMessage } = useMessageService('employeeAccounts');

  const handleErrorsOnSubmit = () => {
    addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
  };

  if (!employeeId) return null;

  const handleSubmit = async (values: FormFieldsData) => updateAccounts(employeeId, values);

  return (
    <FormShowTemplate
      getDataFunc={() => getForUpdate(employeeId)}
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={getAccountsValidationSchema}
      messageContext="employeeAccounts"
      handleErrorsOnSubmit={handleErrorsOnSubmit}
    >
      <AccountsContent employeeId={employeeId} />
    </FormShowTemplate>
  );
};

export default EmployeeAccountsSummary;
